var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
!function (e, t) {
  exports = t();
}(exports, function () {
  "use strict";

  var e;
  e = {
    config: {},
    run: function () {
      return this.getController().processElements();
    },
    process: function (...e) {
      var t, r, n;
      for (r = 0, n = e.length; r < n; r++) t = e[r], this.getController().processElement(t);
      return e.length;
    },
    getController: function () {
      return null != (this || _global).controller ? (this || _global).controller : (this || _global).controller = new e.Controller();
    }
  };
  var t,
    r,
    n,
    a,
    i,
    s,
    o,
    u,
    l,
    c,
    d,
    m,
    h,
    f,
    g,
    p,
    y,
    S,
    v,
    T,
    b,
    M,
    D,
    w,
    E,
    I,
    C,
    N,
    A,
    O,
    $,
    F,
    Y,
    k,
    L,
    W = e;
  return W.config.useFormat24 = !1, W.config.i18n = {
    en: {
      date: {
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        abbrMonthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        yesterday: "yesterday",
        today: "today",
        tomorrow: "tomorrow",
        on: "on {date}",
        formats: {
          default: "%b %e, %Y",
          thisYear: "%b %e"
        }
      },
      time: {
        am: "am",
        pm: "pm",
        singular: "a {time}",
        singularAn: "an {time}",
        elapsed: "{time} ago",
        second: "second",
        seconds: "seconds",
        minute: "minute",
        minutes: "minutes",
        hour: "hour",
        hours: "hours",
        formats: {
          default: "%l:%M%P",
          default_24h: "%H:%M"
        }
      },
      datetime: {
        at: "{date} at {time}",
        formats: {
          default: "%B %e, %Y at %l:%M%P %Z",
          default_24h: "%B %e, %Y at %H:%M %Z"
        }
      }
    }
  }, W.config.locale = "en", W.config.defaultLocale = "en", W.config.timerInterval = 60000, n = !isNaN(Date.parse("2011-01-01T12:00:00-05:00")), W.parseDate = function (e) {
    return e = e.toString(), n || (e = r(e)), new Date(Date.parse(e));
  }, t = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[-+]?[\d:]+)$/, r = function (e) {
    var r, n, a, i, s, o, u, l, c, d;
    if (i = e.match(t)) return [r, c, o, n, a, s, l, d] = i, "Z" !== d && (u = d.replace(":", "")), `${c}/${o}/${n} ${a}:${s}:${l} GMT${[u]}`;
  }, W.elementMatchesSelector = (a = document.documentElement, i = null != (s = null != (o = null != (u = null != (l = a.matches) ? l : a.matchesSelector) ? u : a.webkitMatchesSelector) ? o : a.mozMatchesSelector) ? s : a.msMatchesSelector, function (e, t) {
    if ((null != e ? e.nodeType : void 0) === Node.ELEMENT_NODE) return i.call(e, t);
  }), ({
    config: c
  } = W), ({
    i18n: m
  } = c), W.getI18nValue = function (e = "", {
    locale: t
  } = {
    locale: c.locale
  }) {
    var r;
    return null != (r = d(m[t], e)) ? r : t !== c.defaultLocale ? W.getI18nValue(e, {
      locale: c.defaultLocale
    }) : void 0;
  }, W.translate = function (e, t = {}, r) {
    var n, a, i;
    for (n in i = W.getI18nValue(e, r), t) a = t[n], i = i.replace(`{${n}}`, a);
    return i;
  }, d = function (e, t) {
    var r, n, a, i, s;
    for (s = e, r = 0, a = (i = t.split(".")).length; r < a; r++) {
      if (null == s[n = i[r]]) return null;
      s = s[n];
    }
    return s;
  }, ({
    getI18nValue: f,
    translate: M
  } = W), b = "function" == typeof ("undefined" != typeof Intl && null !== Intl ? Intl.DateTimeFormat : void 0), g = {
    "Central European Standard Time": "CET",
    "Central European Summer Time": "CEST",
    "China Standard Time": "CST",
    "Israel Daylight Time": "IDT",
    "Israel Standard Time": "IST",
    "Moscow Standard Time": "MSK",
    "Philippine Standard Time": "PHT",
    "Singapore Standard Time": "SGT",
    "Western Indonesia Time": "WIB"
  }, W.knownEdgeCaseTimeZones = g, W.strftime = T = function (e, t) {
    var r, n, a, i, s, o, u;
    return n = e.getDay(), r = e.getDate(), s = e.getMonth(), u = e.getFullYear(), a = e.getHours(), i = e.getMinutes(), o = e.getSeconds(), t.replace(/%(-?)([%aAbBcdeHIlmMpPSwyYZ])/g, function (t, l, c) {
      switch (c) {
        case "%":
          return "%";
        case "a":
          return f("date.abbrDayNames")[n];
        case "A":
          return f("date.dayNames")[n];
        case "b":
          return f("date.abbrMonthNames")[s];
        case "B":
          return f("date.monthNames")[s];
        case "c":
          return e.toString();
        case "d":
          return p(r, l);
        case "e":
          return r;
        case "H":
          return p(a, l);
        case "I":
          return p(T(e, "%l"), l);
        case "l":
          return 0 === a || 12 === a ? 12 : (a + 12) % 12;
        case "m":
          return p(s + 1, l);
        case "M":
          return p(i, l);
        case "p":
          return M("time." + (a > 11 ? "pm" : "am")).toUpperCase();
        case "P":
          return M("time." + (a > 11 ? "pm" : "am"));
        case "S":
          return p(o, l);
        case "w":
          return n;
        case "y":
          return p(u % 100, l);
        case "Y":
          return u;
        case "Z":
          return y(e);
      }
    });
  }, p = function (e, t) {
    return "-" === t ? e : `0${e}`.slice(-2);
  }, y = function (e) {
    var t, r, n;
    return (r = h(e)) ? g[r] : (n = v(e, {
      allowGMT: !1
    })) || (n = S(e)) ? n : (t = v(e, {
      allowGMT: !0
    })) ? t : "";
  }, h = function (e) {
    return Object.keys(g).find(function (t) {
      return b ? new Date(e).toLocaleString("en-US", {
        timeZoneName: "long"
      }).includes(t) : e.toString().includes(t);
    });
  }, v = function (e, {
    allowGMT: t
  }) {
    var r;
    if (b && (r = new Date(e).toLocaleString("en-US", {
      timeZoneName: "short"
    }).split(" ").pop(), t || !r.includes("GMT"))) return r;
  }, S = function (e) {
    var t, r, n, a, i;
    return (t = null != (r = (i = e.toString()).match(/\(([\w\s]+)\)$/)) ? r[1] : void 0) ? /\s/.test(t) ? t.match(/\b(\w)/g).join("") : t : (t = null != (n = i.match(/(\w{3,4})\s\d{4}$/)) ? n[1] : void 0) || (t = null != (a = i.match(/(UTC[\+\-]\d+)/)) ? a[1] : void 0) ? t : void 0;
  }, W.CalendarDate = class {
    static fromDate(e) {
      return new this(e.getFullYear(), e.getMonth() + 1, e.getDate());
    }
    static today() {
      return this.fromDate(new Date());
    }
    constructor(e, t, r) {
      this.date = new Date(Date.UTC(e, t - 1)), this.date.setUTCDate(r), this.year = this.date.getUTCFullYear(), this.month = this.date.getUTCMonth() + 1, this.day = this.date.getUTCDate(), this.value = this.date.getTime();
    }
    equals(e) {
      return (null != e ? e.value : void 0) === this.value;
    }
    is(e) {
      return this.equals(e);
    }
    isToday() {
      return this.is(this.constructor.today());
    }
    occursOnSameYearAs(e) {
      return this.year === (null != e ? e.year : void 0);
    }
    occursThisYear() {
      return this.occursOnSameYearAs(this.constructor.today());
    }
    daysSince(e) {
      if (e) return (this.date - e.date) / 86400000;
    }
    daysPassed() {
      return this.constructor.today().daysSince(this);
    }
  }, ({
    strftime: E,
    translate: I,
    getI18nValue: w,
    config: D
  } = W), W.RelativeTime = class {
    constructor(e) {
      this.date = e, this.calendarDate = W.CalendarDate.fromDate(this.date);
    }
    toString() {
      var e, t;
      return (t = this.toTimeElapsedString()) ? I("time.elapsed", {
        time: t
      }) : (e = this.toWeekdayString()) ? (t = this.toTimeString(), I("datetime.at", {
        date: e,
        time: t
      })) : I("date.on", {
        date: this.toDateString()
      });
    }
    toTimeOrDateString() {
      return this.calendarDate.isToday() ? this.toTimeString() : this.toDateString();
    }
    toTimeElapsedString() {
      var e, t, r, n, a;
      return r = new Date().getTime() - this.date.getTime(), n = Math.round(r / 1000), t = Math.round(n / 60), e = Math.round(t / 60), r < 0 ? null : n < 10 ? (a = I("time.second"), I("time.singular", {
        time: a
      })) : n < 45 ? `${n} ${I("time.seconds")}` : n < 90 ? (a = I("time.minute"), I("time.singular", {
        time: a
      })) : t < 45 ? `${t} ${I("time.minutes")}` : t < 90 ? (a = I("time.hour"), I("time.singularAn", {
        time: a
      })) : e < 24 ? `${e} ${I("time.hours")}` : "";
    }
    toWeekdayString() {
      switch (this.calendarDate.daysPassed()) {
        case 0:
          return I("date.today");
        case 1:
          return I("date.yesterday");
        case -1:
          return I("date.tomorrow");
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          return E(this.date, "%A");
        default:
          return "";
      }
    }
    toDateString() {
      var e;
      return e = this.calendarDate.occursThisYear() ? w("date.formats.thisYear") : w("date.formats.default"), E(this.date, e);
    }
    toTimeString() {
      var e;
      return e = D.useFormat24 ? "default_24h" : "default", E(this.date, w(`time.formats.${e}`));
    }
  }, ({
    elementMatchesSelector: C
  } = W), W.PageObserver = class {
    constructor(e, t) {
      this.processMutations = this.processMutations.bind(this), this.processInsertion = this.processInsertion.bind(this), this.selector = e, this.callback = t;
    }
    start() {
      if (!this.started) return this.observeWithMutationObserver() || this.observeWithMutationEvent(), this.started = !0;
    }
    observeWithMutationObserver() {
      if ("undefined" != typeof MutationObserver && null !== MutationObserver) return new MutationObserver(this.processMutations).observe(document.documentElement, {
        childList: !0,
        subtree: !0
      }), !0;
    }
    observeWithMutationEvent() {
      return addEventListener("DOMNodeInserted", this.processInsertion, !1), !0;
    }
    findSignificantElements(e) {
      var t;
      return t = [], (null != e ? e.nodeType : void 0) === Node.ELEMENT_NODE && (C(e, this.selector) && t.push(e), t.push(...e.querySelectorAll(this.selector))), t;
    }
    processMutations(e) {
      var t, r, n, a, i, s, o, u;
      for (t = [], r = 0, a = e.length; r < a; r++) if ("childList" === (s = e[r]).type) for (n = 0, i = (u = s.addedNodes).length; n < i; n++) o = u[n], t.push(...this.findSignificantElements(o));
      return this.notify(t);
    }
    processInsertion(e) {
      var t;
      return t = this.findSignificantElements(e.target), this.notify(t);
    }
    notify(e) {
      if (null != e ? e.length : void 0) return "function" == typeof this.callback ? this.callback(e) : void 0;
    }
  }, ({
    parseDate: O,
    strftime: $,
    getI18nValue: A,
    config: N
  } = W), W.Controller = function () {
    var e, t, r, n;
    return e = "time[data-local]:not([data-localized])", t = function (e) {
      return e.setAttribute("data-localized", "");
    }, r = function (e) {
      return e.setAttribute("data-processed-at", new Date().toISOString());
    }, n = function (e) {
      return new W.RelativeTime(e);
    }, class {
      constructor() {
        this.processElements = this.processElements.bind(this), this.pageObserver = new W.PageObserver(e, this.processElements);
      }
      start() {
        if (!this.started) return this.processElements(), this.startTimer(), this.pageObserver.start(), this.started = !0;
      }
      startTimer() {
        var e;
        if (e = N.timerInterval) return null != this.timer ? this.timer : this.timer = setInterval(this.processElements, e);
      }
      processElements(t = document.querySelectorAll(e)) {
        var r, n, a;
        for (n = 0, a = t.length; n < a; n++) r = t[n], this.processElement(r);
        return t.length;
      }
      processElement(e) {
        var a, i, s, o, u, l;
        if (a = e.getAttribute("datetime"), s = e.getAttribute("data-local"), i = N.useFormat24 && e.getAttribute("data-format24") || e.getAttribute("data-format"), o = O(a), !isNaN(o)) return e.hasAttribute("title") || (l = N.useFormat24 ? "default_24h" : "default", u = $(o, A(`datetime.formats.${l}`)), e.setAttribute("title", u)), r(e), e.textContent = function () {
          switch (s) {
            case "time":
              return t(e), $(o, i);
            case "date":
              return t(e), n(o).toDateString();
            case "time-ago":
              return n(o).toString();
            case "time-or-date":
              return n(o).toTimeOrDateString();
            case "weekday":
              return n(o).toWeekdayString();
            case "weekday-or-date":
              return n(o).toWeekdayString() || n(o).toDateString();
          }
        }();
      }
    };
  }.call(window), L = !1, F = function () {
    return document.attachEvent ? "complete" === document.readyState : "loading" !== document.readyState;
  }, Y = function (e) {
    var t;
    return null != (t = "function" == typeof requestAnimationFrame ? requestAnimationFrame(e) : void 0) ? t : setTimeout(e, 17);
  }, k = function () {
    return W.getController().start();
  }, W.start = function () {
    return L ? W.run() : (L = !0, "undefined" != typeof MutationObserver && null !== MutationObserver || F() ? k() : Y(k));
  }, W.processing = function () {
    return W.getController().started;
  }, window.LocalTime === W && W.start(), W;
});
export default exports;